import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-microInverter",
  "use": "dv-microInverter-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"dv-microInverter\"><defs><style>#dv-microInverter .cls-1{fill:#fff1de;fill-opacity:0;}</style></defs><title>04</title><g id=\"dv-microInverter_图层_2\" data-name=\"图层 2\"><g id=\"dv-microInverter_图层_1-2\" data-name=\"图层 1\"><rect id=\"dv-microInverter_矩形_265\" data-name=\"矩形 265\" class=\"cls-1\" width=\"17\" height=\"17\" /><path id=\"dv-microInverter_减去_171\" data-name=\"减去 171\" d=\"M14.58,14.5H2.41a1.2,1.2,0,0,1-1.2-1.2h0v-1H0v-.76H1.21v-.77H0V10H1.21V3.7a1.2,1.2,0,0,1,1.2-1.2H14.58a1.2,1.2,0,0,1,1.2,1.2h0V6.86H17v.77H15.78v.76H17v.76H15.78V13.3a1.19,1.19,0,0,1-1.19,1.2ZM10,6.23V9.92h.58V6.23ZM8.57,7h0V7h0c0,.33-.07.79-.07,1.11V9.92h.54V6.23H8.39L7.73,8.1c-.05.12-.08.24-.12.36v0l-.11.35h0c0-.12-.08-.23-.11-.35s-.09-.26-.13-.4L6.54,6.23H5.88V9.91H6.4V8.1c0-.26,0-.6-.05-.9h0V7.1s0-.1,0-.14h0l.29.85.64,1.76h.36l.65-1.76L8.58,7Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-microInverter.svg
// module id = 9PNy
// module chunks = 268